import { Box, Typography } from '@mui/material'
import CustomCheckbox from '../../components/Inputs/CustomCheckbox'
import CustomOption from '../../components/Inputs/CustomOption'
import CustomSlider from '../../components/Inputs/CustomSlider'
import Instructions from './Instructions'
const WorkSite = () => {
  return (
    <Box sx={{ padding: '20px 0px 40px 0px' }}>
      <Typography
        align="center"
        className="general-text"
        sx={{ mb: 4, fontWeight: 700 }}
      >
        COVID 19 SAFE WORK PLAN
      </Typography>
      <Typography sx={{ mb: 3 }} className="general-text-light">
        <span className="general-text">Task Name:</span>{' '}
        <span style={{ color: 'red' }}>Attending work site</span>
      </Typography>
      <Typography sx={{ mb: 3 }} className="general-text">
        Would this Hazardous Element exist on this worksite?
      </Typography>
      <CustomCheckbox
        label="Attracting COVID-19 from clients, other workers or surfaces"
        name="attracting_covid_from_clients"
        component={
          <Box>
            <Typography className="general-text">
              What are the hazards and risks?
            </Typography>
            <CustomOption
              label="Workers or others catching COVID-19 (could result in serious illness or death)."
              name="workers_or_others_catching_covid"
              component={
                <Box>
                  <CustomSlider
                    label="Inherent Risk Rating - (Workers or others catching COVID-19 (could result in serious illness or death))"
                    name="inherent_risk_rating"
                  />
                  <Typography color="primary" className="general-text">
                    How will the hazards and risk be controlled?
                  </Typography>
                  <Instructions />
                  <CustomSlider
                    label="Residual Risk Rating - (Workers or others catching COVID-19 (could result in serious illness or death))"
                    name="residual_risk_rating"
                  />
                </Box>
              }
            />
          </Box>
        }
        conditional_heading="Hazardous Material"
      />
      <CustomCheckbox
        label="Alcohol based sanitiser"
        name="alcohol_based_sanitiser"
        component={
          <Box>
            <Typography className="general-text">
              What are the hazards and risks?
            </Typography>
            <CustomOption
              label="Dermatitis"
              name="dermatitis"
              component={
                <Box>
                  <CustomSlider
                    label="Inherent Risk Rating - (Dermatitis)"
                    name="inherent_risk_rating_dermatitis"
                  />
                  <Typography color="primary" className="general-text">
                    How will the hazards and risk be controlled?
                  </Typography>
                  <Typography className="general-text">
                    Staff are encouraged to wash hands with soap and water for
                    20 secs where possible as an alternative to hand sanitiser
                  </Typography>
                  <CustomSlider
                    label="Residual Risk Rating - (Dermatitis)"
                    name="residual_risk_rating_dermatitis"
                  />
                </Box>
              }
            />
          </Box>
        }
        conditional_heading="Hazardous Material"
      />
    </Box>
  )
}

export default WorkSite
